import { securedFetch } from "../auth/authService";
import { DEVICE_API, VALIDATION_RESULT_API } from "../vars";

export async function getViolationsStatus() {
    return securedFetch(`${VALIDATION_RESULT_API}/status`)
        .then(response => response.json())
}

export async function getDevicesStatus() {
    return securedFetch(`${DEVICE_API}/status`)
        .then(response => response.json());
}
